// Global Instructions Rule Applied!
//
// tel: / mailto: / external-URL hrefs — promoted from the mobile companion
// (mobile/lib/format.ts + ContactScreen) so desktop read-mode fields render
// phone numbers, emails and URLs as working links (owner request 2026-08-26).

/** tel: link — whitespace stripped so dialers accept it. */
export const telHref = (phone: unknown): string => `tel:${String(phone ?? '').replace(/\s+/g, '')}`

/** mailto: link. */
export const mailHref = (email: unknown): string => `mailto:${String(email ?? '').trim()}`

/** Ensure a user-entered URL has a protocol so it opens as an external link. */
export function externalHref(url?: unknown): string {
  const s = String(url || '').trim()
  if (!s) return '#'
  return /^https?:\/\//i.test(s) ? s : `https://${s}`
}
